import { createApp } from "vue";
import App from "./App.vue";
import "@accelerateadvisory/frontend-core/dist/frontend-core.css";
import "./assets/global.css";

createApp(App).mount("#app");
